import { Typography } from '@atgfr8/atg-ui-tailwind';
import { Customer } from '@store/customers/types';
import { formatPhoneNumber } from '@utils/phoneNumberFormat';
import { get } from 'lodash';

export const CustomeInfoDetails = (data: Customer) => {
  return (
    <>
      <Typography variant="body1" component="p" class="text-xs!">
        {get(data, 'contactName', '')}
      </Typography>
      <a href={`mailto:${get(data, 'contactEmail', '')}`}>
        <Typography
          variant="body1"
          component="p"
          class="text-xs! text-[#026EA1]! hover:underline! whitespace-normal! break-all!"
        >
          {get(data, 'contactEmail', '')}
        </Typography>
      </a>
      <a href={`tel:${get(data, 'contactPhone', '')}`}>
        <Typography
          variant="body1"
          component="p"
          class="text-xs! text-[#026EA1]! hover:underline!"
        >
          {formatPhoneNumber(get(data, 'contactPhone', '')!)}
        </Typography>
      </a>
    </>
  );
};
